import React, { Component } from 'react';

import { connect } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ScrollToTop from 'react-scroll-up';
import { ChevronUpIcon } from 'mdi-react';

/**
 * Containers.
 */
import FirstSection from 'modules/landing/containers/first-section';
import SecondSection from 'modules/landing/containers/second-section';
import ThirdSection from 'modules/landing/containers/third-section';
import FourthSection from 'modules/landing/containers/fourth-section';
import FifthSection from 'modules/landing/containers/fifth-section';
import Footer from 'modules/landing/containers/footer';

/**
 * Actions
 */
import { createProposal as createProposalAction } from 'modules/affiliation/actions/affiliation.action';

/**
 * Style.
 */
import './home.scss';

class Home extends Component {
  constructor(props) {
    super(props);
    this.secondSectionRef = React.createRef();
    this.thirdSectionRef = React.createRef();
    this.fourthSectionRef = React.createRef();
    this.fifthSectionRef = React.createRef();

    this.references = {
      sobre: this.secondSectionRef,
      beneficios: this.thirdSectionRef,
      comoFunciona: this.fourthSectionRef,
      AfiliarSe: this.fifthSectionRef,
    };
  }

  /**
   * @param {string} key - Either one of those
   * ('sobre' | 'beneficios' | 'comoFunciona' | 'AfiliarSe')
   *
   * @description Scroll document to specific section.
   */
  goTo = (key) => {
    const { references } = this;
    const { current: referenceToGo } = references[`${key}`];
    const { y: yAxisToGo } = referenceToGo.getBoundingClientRect();

    window.scrollBy({
      top: yAxisToGo,
      behavior: 'smooth',
    });
  }

  /**
   * @description Shortcut to scroll all the way down to afiliation.
   */
  goToAfiliation = () => this.goTo('AfiliarSe');

  goToAbout = () => this.goTo('sobre');

  handleSubmit = (data) => {
    const { createProposal, history } = this.props;

    const params = {
      ...data,
    };

    return createProposal(params)
      .then(() => history.push('/afiliacao'))
      .catch((err) => {
        toast(() => err.message, {
          type: toast.TYPE.ERROR,
        });
      });
  }

  render() {
    return (
      <div className="home-wrapper">

        {/* First Section. ~Intro~ ~HEADER INSIDE~ */}
        <FirstSection
          goTo={this.goTo}
          goToAbout={this.goToAbout}
          goToAfiliation={this.goToAfiliation}
        />

        {/* Second Section. ~Sobre~ */}
        <SecondSection
          reference={this.secondSectionRef}
          goToBeneffits={() => this.goTo('beneficios')}
        />

        {/* Third Section. ~Benefícios~ */}
        <ThirdSection
          reference={this.thirdSectionRef}
        />

        {/* Fourth Section. ~Como Funciona~ */}
        <FourthSection
          reference={this.fourthSectionRef}
          goToAfiliation={this.goToAfiliation}
        />

        {/* Fifth Section. ~Afiliar-se~ */}
        <FifthSection
          reference={this.fifthSectionRef}
          onSubmitForm={this.handleSubmit}
        />

        {/* Footer */}
        <Footer />

        <ToastContainer />

        <ScrollToTop showUnder={160}>
          <div
            style={{
              width: 36,
              height: 36,
              backgroundColor: 'rgba(0,0,0, .7)',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ChevronUpIcon color="white" />
          </div>
        </ScrollToTop>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  createProposal: (proposal) => dispatch(createProposalAction(proposal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
